module.exports = __webpack_public_path__ + "img/familiacarro.7345932a.jpg";